

import TextInput from "/src/components/UI/TextField/TextInput"
import './InputSearch.css';
import "/src/assets/css/polices.css"
function InputSearch({ name, timeout ,placeholderLibelle, onChange, style = {} }) {

    var typingTimer;
    const onKeyUp = (e) => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(() => onChange(e), timeout);
    }
    return (
        <>
            <div className="inputSearch-container" style={{...style}}>
                <TextInput onKeyUp={onKeyUp} className="inputSearch placeholder-input" placeholder={"Filter by " + placeholderLibelle} name={name}></TextInput>
            </div>
        </>

    )
}

InputSearch.defaultProps = {
    timeout : 500
}

export default InputSearch
